import BaseAccordionTab from '../../sisu/panel/BaseAccordionTab.sisu'

const NeoAccordionTab = BaseAccordionTab

export default NeoAccordionTab;